/*
This file is generated.
Do not modify manually, instead refer to build-sounds.js
*/
// tslint:disable
/* es-lint:disable */
import { utilVersion } from "../utils/utilVersion";
export var assetBundleSoundSound = {
    ogg: process.env.PUBLIC_URL + "/sound/sound-Sound.ogg?v=" + utilVersion.getCurrentVersion(),
    m4a: process.env.PUBLIC_URL + "/sound/sound-Sound.m4a?v=" + utilVersion.getCurrentVersion(),
    mp3: process.env.PUBLIC_URL + "/sound/sound-Sound.mp3?v=" + utilVersion.getCurrentVersion(),
    ac3: process.env.PUBLIC_URL + "/sound/sound-Sound.ac3?v=" + utilVersion.getCurrentVersion(),
};



//////////////////
// WEBPACK FOOTER
// ./src/assetBundles/assetBundleSoundSound.ts
// module id = 2515
// module chunks = 3